<template>
    <div>
        <div v-if="!creating && !editing" class="row">
            <div class="col-6">
                <b-col sm="10" offset="2" class="p-0">
                    <h4>Commissaires aux comptes enregistrés</h4>
                    <b-alert :show="noAuditor" variant="primary">
                        Aucun·e commissaire aux comptes n'a été saisi·e pour
                        cette société
                    </b-alert>

                    <div>
                        <auditor
                            v-for="auditor in auditors"
                            :key="'auditor' + auditor.id"
                            :item="auditor"
                            :can-edit="false"
                            @auditor-is-deleted="
                                $emit('pappers-auditors-is-updated')
                            "
                        />
                    </div>
                </b-col>
            </div>
            <div class="col-6">
                <b-col sm="10" offset="2" class="p-0">
                    <h4>Commissaires aux comptes communiqués par Pappers</h4>
                    <b-alert :show="noPappersAuditor" variant="primary">
                        Aucune donnée Pappers
                    </b-alert>
                    <div v-if="!loading">
                        <div v-if="!creating && !editing">
                            <pappers-auditor
                                v-for="auditor in pappersAuditors"
                                :key="'papperAuditor' + auditor.id"
                                :item="auditor"
                                :company="company"
                                @auditor-is-stored="
                                    $emit('pappers-auditors-is-updated')
                                "
                            />
                        </div>
                    </div>
                    <div v-else>
                        <b-card>
                            <loading/>
                        </b-card>
                    </div>
                </b-col>
            </div>
        </div>

        <div v-if="personType === 'moral'">
            <moral-person-search v-if="searching"/>
            <moral-person-create v-if="creating"/>
            <moral-person-edit v-if="editing"/>
        </div>

        <div v-if="personType === 'physical'">
            <physical-person-search v-if="searching"/>
            <physical-person-create v-if="creating"/>
            <physical-person-edit v-if="editing"/>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Auditor from './Auditor'
import MoralPersonSearch from '../moralPersons/MoralPersonSearch'
import PhysicalPersonSearch from '../physicalPersons/PhysicalPersonSearch'
import PhysicalPersonCreate from '../physicalPersons/PhysicalPersonCreate'
import PhysicalPersonEdit from '../physicalPersons/PhysicalPersonEdit'
import MoralPersonCreate from '../moralPersons/MoralPersonCreate'
import MoralPersonEdit from '../moralPersons/MoralPersonEdit'
import PappersAuditor from './PappersAuditor'
import loading from '../../../../common/components/loading'

export default {
    name: 'PappersAuditors',

    components: {
        PappersAuditor,
        MoralPersonSearch,
        MoralPersonCreate,
        MoralPersonEdit,
        PhysicalPersonSearch,
        PhysicalPersonCreate,
        PhysicalPersonEdit,
        Auditor,
    },

    props: {
        company: null,
    },

    data() {
        return {
            loading: false,
        }
    },

    created() {
        this.$store.commit('legalVM/RESET_STATUS')
    },

    methods: {
        showSearch(type) {
            this.$store.commit('legalVM/SET_PERSON_TYPE', type)
            this.$store.commit('legalVM/SET_LINK_TYPE', 'auditors')
            this.$store.commit('legalVM/SHOW_SEARCH')
        },

        showEdit() {
            this.$store.commit('legalVM/SET_LINK_TYPE', 'auditors')
            this.$store.commit('legalVM/SHOW_EDIT')
        },

        resetKey() {
            this.key = Date.now()
        },

        async updatePappers() {
            this.loading = true
            this.pappers = {}
            try {
                await axios.put(
                    `/moralPersons/${this.company.main_moral_person_id}/pappers`
                )
                this.$emit('pappers-auditors-is-updated')
                this.loading = false
                this.resetKey()
            } catch (error) {
                console.error(error)
            }
        },
    },

    computed: {
        ...mapState({
            editing: (state) => state.legalVM.editing,
            searching: (state) => state.legalVM.searching,
            creating: (state) => state.legalVM.creating,
            personType: (state) => state.legalVM.personType,
        }),

        auditors() {
            return this.company.auditors === null || this.company.auditors === undefined
                ? null
                : this.company.auditors.data
        },

        noAuditor() {
            return this.auditors === null || (this.auditors.length === 0 && !this.searching && !this.editing)
        },

        pappersAuditors() {
            return this.company.pappers_data === null || this.company.pappers_data === undefined
                ? null
                : this.company.pappers_data.chiefs.filter(
                    (item) => item.is_auditor
                )
        },

        noPappersAuditor() {
            return this.pappersAuditors === null || (
                this.pappersAuditors.length === 0 &&
                !this.searching &&
                !this.editing
            )
        },
    },
}
</script>

<style scoped></style>
